import _ from 'underscore';
import storage from 'local-storage-fallback';

export default class AppStorage {

    static get(key) {
        const value = storage.getItem(key);
        return _.isNull(value) ? value : JSON.parse(value);
    }

    static set(key, value) {
        storage.setItem(key, JSON.stringify(value));
    }

}


// WEBPACK FOOTER //
// ./core/AppStorage.js